import React from 'react'
import TenableWebappMappingForm from './TenableWebappMappingForm';
import TenableWebappCredentialsForm from './TenableWebappCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function TenableWebappConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={TenableWebappMappingForm}
            CredentialsForm={TenableWebappCredentialsForm}
            componentName="Scan Config Name (ID)"
            componentKey="configName"
        />
    )
}